/**
 * @voltxampere/ui — Command pattern base (Sprint 13)
 *
 * Per ADR-0017. Each circuit-mutating action implements `Command`:
 * `do(circuit) → circuit` and `undo(circuit) → circuit`. Both
 * functions are pure — Sprint 12's `currentCircuit` signal stays
 * immutable, mutation is structural-share.
 *
 * `BatchCommand` wraps an ordered list so multi-select drag (or
 * cut = copy + delete) collapses to one undo step.
 *
 * Sprint 19 persistence will add a `serialize() / deserialize()`
 * pair so undo state survives reload; Sprint 13 keeps the stack
 * memory-only.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
/**
 * Group several commands into a single undo step. `do` runs them
 * left-to-right; `undo` runs them right-to-left so dependent
 * mutations unwind in the correct order (Sprint 13 cut: delete
 * needs to undo *before* the post-delete copy snapshot becomes
 * stale, etc.).
 */
export class BatchCommand {
    commands;
    description;
    constructor(commands, description) {
        this.commands = commands;
        this.description = description;
    }
    do(circuit) {
        let next = circuit;
        for (const cmd of this.commands)
            next = cmd.do(next);
        return next;
    }
    undo(circuit) {
        let next = circuit;
        for (let i = this.commands.length - 1; i >= 0; i--) {
            const cmd = this.commands[i];
            if (cmd)
                next = cmd.undo(next);
        }
        return next;
    }
    describe() {
        return this.description;
    }
    /** Test surface — inspect the wrapped commands. */
    get size() {
        return this.commands.length;
    }
}
//# sourceMappingURL=base.js.map